import { Injectable, inject } from '@angular/core';

import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';

import { CorrectScoreOptions, CorrectScoreService } from './correct-score.service';

export interface CorrectScoreColumnOptions {
    left: EventOption[];
    middle: EventOption[];
    right: EventOption[];
    rest: EventOption[];
}

@Injectable({ providedIn: 'root' })
export class USCorrectScoreService {
    private correctScoreService = inject(CorrectScoreService);

    getUSCorrectScoreOptions(optionGroup: EventOptionGroup, pushRestToTheMiddle: boolean = false): CorrectScoreOptions {
        if (!optionGroup) {
            throw new Error('Invalid getCorrectScoreOptions arguments. OptionGroup is required.');
        }

        if (optionGroup.options.length === 0) {
            return { layout: 3, options: [], rest: [] };
        }

        const columns: CorrectScoreColumnOptions = {
            left: [],
            middle: [],
            right: [],
            rest: [],
        };

        optionGroup.options
            .filter((option) => option && option.name)
            .forEach((option) => {
                const parsedScores = this.parseScores(option.name);
                if (!parsedScores) {
                    columns.rest.push(option);
                    return;
                }

                const { homeScore, awayScore } = parsedScores;

                const targetColumn = homeScore > awayScore ? columns.left : awayScore > homeScore ? columns.right : columns.middle;

                targetColumn.push(option);

                option.player1Score = homeScore;
                option.player2Score = awayScore;
            });

        return this.correctScoreService.mapColumnOptions(columns.left, columns.middle, columns.right, columns.rest, pushRestToTheMiddle);
    }

    private parseScores(name: string): { homeScore: number; awayScore: number } | null {
        const [home, away] = name.match(/\d+/g)?.map(Number) ?? [];
        return home != null && away != null ? { homeScore: home, awayScore: away } : null;
    }
}
